import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import type { NodeSpec } from './NodeSpec';

export const notUiNodeSpec: NodeSpec<NodeCfg<'not'>> = {
    requiredSockets: 'all',
    cfg: () => ({ controlValues: {}, id: getUID(), kind: 'not', disabled: false }),
    controls: () => ({}),
    inputs: () => ({ input: { socket: 'boolean', label: 'Input' } }),
    kindLabel: 'Boolean NOT',
    nodeCategory: 'boolean',
    outputs: () => ({ output: { socket: 'boolean', label: 'Output' } }),
    validator: () => true,
};
